/**   
<summary>
  This functional component "UnsavedChangesPopup" renders a confirmation modal
  when user tries to switch context without saving changes.
  
  1. Displays a modal dialog asking whether to save unsaved changes.
  2. Uses "modalSubmit" to save changes.
  3. Uses "modalClosed" to close the modal without saving.
  4. Shows loading state on save button using "isLoading".

* @author Chandan Singh
* @created Date: 08-May-2026
</summary>
<returns>Returns JSX</returns>
*/

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import LoaderButton from '../../../shared/components/Button/LoaderButton';

interface Props {
    modalSubmit: () => void;
    modalClosed: () => void;
    isLoading: boolean;
    userInfo:any
}

const UnsavedChangesPopup: React.FC<Props> = props => {
    return (
        <Modal
            show={true}
            centered
            onHide={props.modalClosed}
            dialogClassName="delete-popup"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id='Application_Title' />
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="bootbox-body">
                    <FormattedMessage id='You_Have_Unsaved_Changes_For' /> {props.userInfo?.UserName}. <FormattedMessage id='Do_You_Want_To_Save_Before_Continuing' />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <LoaderButton
                    type="submit"
                    onClick={props.modalSubmit}
                    isLoading={props.isLoading}
                    text="Button_Save"
                />

                <Button
                    variant="primary"
                    onClick={props.modalClosed}
                    className="btnOkSize"
                >
                    <FormattedMessage id='Button_Cancel' />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UnsavedChangesPopup;